import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import "./Projects.css";
import Twb from "../modal/twb/Twb";
import Dominious from "../modal/twb/Dominous";
import Testimony from "../modal/twb/Testimonial";
import BuzzLife from "../modal/twb/Buzzlife";
import Photography from "../modal/twb/Photography";
import Market from "../modal/twb/Market";
import WorldRank from "../modal/twb/WorldRank";
import TechUni from "../modal/twb/TechUni";
import Movers from "../modal/twb/Movers";
import Sweet from "../modal/twb/Sweet";
import Ace from "../modal/twb/Ace";
import Oliveagro from "../modal/twb/Oliveagro";

const Projects = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className='projects' id='work'>
      <Container>
        <h1 className='project-title'>Projects</h1>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              Recent Projects
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                toggle("2");
              }}
            >
              Ruby on Rails
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => {
                toggle("3");
              }}
            >
              React / Nextjs
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "5" })}
              onClick={() => {
                toggle("5");
              }}
            >
              Html / Css
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId='1'>
            <Row className=''>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614079373/FireShot_Capture_151_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_aa5lab.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Travel with Benefit</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Twb className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Twb className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1618402166/FireShot_Capture_253_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_snwfqq.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Oliveagro</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Redux</div>
                    <div className='tags'>Node</div>
                  </div>
                  <Oliveagro className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Redux</div>
                    <div className='tags'>Node</div>
                  </div>
                  <Oliveagro className='button' />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614134014/FireShot_Pro_Webpage_Screenshot_005_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_jvlwwn.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Testimonial</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>Redux</div>
                  </div>
                  <Testimony className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>Redux</div>
                  </div>
                  <Testimony className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135741/FireShot_Pro_Webpage_Screenshot_012_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_zjyod9.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Dominous Restaurant</h1>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Javascript</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Dominious className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Javascript</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Dominious className='button' />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614134903/FireShot_Pro_Webpage_Screenshot_007_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_h6xcu8.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>World Ranks</h1>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Api</div>
                    <div className='tags'>Html/Css</div>
                  </div>
                  <WorldRank className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Map Api</div>
                    <div className='tags'>Html/Css</div>
                  </div>
                  <WorldRank className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614136718/FireShot_Pro_Webpage_Screenshot_015_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_vssfka.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Market Place</h1>
                  <di className='tag-body'>
                    <div className='tags'>Html</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Javascript</div>
                  </di>
                  <Market className='button' />
                </div>
                <div className='none'>
                  <di className='tag-body'>
                    <div className='tags'>Html</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Javascript</div>
                  </di>
                  <Market className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135966/FireShot_Pro_Webpage_Screenshot_013_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_hsldmh.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Photography</h1>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Photography className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Photography className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614137511/FireShot_Pro_Webpage_Screenshot_016_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_sf69qw.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Movers</h1>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Movers className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Movers className='button' />
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='2'>
            <Row className=''>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135741/FireShot_Pro_Webpage_Screenshot_012_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_zjyod9.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Dominous Restaurant</h1>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Dominious className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Dominious className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614130928/FireShot_Capture_220_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_vh5vbs.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>BuzzLife</h1>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <BuzzLife className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <BuzzLife className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135251/FireShot_Pro_Webpage_Screenshot_008_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_vi8cqa.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Tech University</h1>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <TechUni />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <TechUni />
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='3'>
            <Row className=''>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1618402166/FireShot_Capture_253_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_snwfqq.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Oliveagro</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Redux</div>
                    <div className='tags'>Node</div>
                  </div>
                  <Oliveagro className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Redux</div>
                    <div className='tags'>Node</div>
                  </div>
                  <Oliveagro className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614079373/FireShot_Capture_151_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_aa5lab.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Travel with Benefit</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Twb className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Ruby on Rails</div>
                    <div className='tags'>PostgresQl</div>
                  </div>
                  <Twb className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614134014/FireShot_Pro_Webpage_Screenshot_005_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_jvlwwn.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Testimonial</h1>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>Redux</div>
                  </div>
                  <Testimony className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>React</div>
                    <div className='tags'>Material UI</div>
                    <div className='tags'>Redux</div>
                  </div>
                  <Testimony className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614134903/FireShot_Pro_Webpage_Screenshot_007_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_h6xcu8.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>World Rank</h1>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <WorldRank className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <WorldRank className='button' />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614135966/FireShot_Pro_Webpage_Screenshot_013_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_hsldmh.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Photography</h1>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Photography className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Nextjs</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Photography className='button' />
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='5'>
            <Row className=''>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614136718/FireShot_Pro_Webpage_Screenshot_015_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_vssfka.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Market Place</h1>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Market className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Market className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614137511/FireShot_Pro_Webpage_Screenshot_016_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_sf69qw.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Movers</h1>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Movers className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Movers className='button' />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614189226/FireShot_Pro_Webpage_Screenshot_021_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_rnow1o.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Sweet Sensation</h1>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Sweet className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Sweet className='button' />
                </div>
              </Col>
              <Col sm='12' md='5' className='project contain mx-4 my-3'>
                <img
                  src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614134574/FireShot_Pro_Webpage_Screenshot_006_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_p1sd6m.png'
                  alt='Avatar'
                  className='image'
                />
                <div className='middle'>
                  <h1>Black Ace</h1>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Ace className='button' />
                </div>
                <div className='none'>
                  <div className='tag-body'>
                    <div className='tags'>Bootstrap</div>
                    <div className='tags'>Css</div>
                    <div className='tags'>Html</div>
                  </div>
                  <Ace className='button' />
                </div>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

export default Projects;
